import { ButtonProps } from "@material-ui/core";
import { KeyboardArrowRight } from "@material-ui/icons";
import React, { FunctionComponent } from "react";

import { Button } from "./button";

export const ActionButton: FunctionComponent<ButtonProps> = (props) => (
  <Button endIcon={<KeyboardArrowRight />} {...props} />
);
